import { createAction } from 'redux-actions';

export const MessageType = Object.freeze({
  success: 1,
  information: 2,
  warning: 3,
  danger: 4,
  0: 'danger',
  1: 'success',
  2: 'information',
  3: 'warning',
  4: 'danger',
  400: 'danger',
  401: 'danger',
  403: 'danger',
  404: 'danger',
  500: 'danger',
  parse: input => {
    if (typeof input === 'number') {
      return MessageType[MessageType[input]] || MessageType.danger;
    }
    return MessageType[input] || MessageType.danger;
  },
  toString: type => MessageType[MessageType.parse(type)],
});

export function encodeActionType(type, payload) {
  return JSON.stringify({ type, payload });
}

export function decodeActionType({ action }) {
  return JSON.parse(action);
}

export const notify = createAction('NOTIFY_USER', (type, content, data, desktop) => ({
  type,
  content,
  data,
  desktop,
}));
export const dismiss = createAction('DISMISS_NOTIFICATION', key => ({ key }));

export default {
  notify,
  dismiss,
};
